import { render } from "./TemplateViewer.vue?vue&type=template&id=cc579382&scoped=true&ts=true"
import script from "./TemplateViewer.vue?vue&type=script&lang=ts"
export * from "./TemplateViewer.vue?vue&type=script&lang=ts"

import "./TemplateViewer.vue?vue&type=style&index=0&id=cc579382&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc579382"]])

export default __exports__